var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M42.1143 4.69412C41.6184 2.85882 40.1662 1.41176 38.3244 0.917647C34.9595 0 21.4999 0 21.4999 0C21.4999 0 8.04033 0 4.67543 0.882353C2.86902 1.37647 1.38138 2.85882 0.885499 4.69412C0 8.04706 0 15 0 15C0 15 0 21.9882 0.885499 25.3059C1.38138 27.1412 2.8336 28.5882 4.67543 29.0824C8.07575 30 21.4999 30 21.4999 30C21.4999 30 34.9595 30 38.3244 29.1176C40.1662 28.6235 41.6184 27.1765 42.1143 25.3412C42.9998 21.9882 42.9998 15.0353 42.9998 15.0353C42.9998 15.0353 43.0352 8.04706 42.1143 4.69412Z","fill":"#FF0000","key":0}),React.createElement("path",{"d":"M28.4066 15.0002L17.2139 8.57666V21.4237L28.4066 15.0002Z","fill":"white","key":1})]);
}

Youtube.defaultProps = {"width":"43","height":"30","viewBox":"0 0 43 30","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
